import React, { useState, useEffect } from 'react';
import { Tour } from 'antd';

const TourWidget = ({ open, onClose }) => {
    const [current, setCurrent] = useState(0);

    const steps = [
        // Начало тура
        {
            title: '👋 Добро пожаловать в генератор открыток!',
            description: 'Этот мастер поможет вам быстро освоить все возможности редактора. Мы пройдем путь от создания одного сертификата до массовой генерации из таблицы данных.',
            placement: 'center',
            target: () => null,
        },
        {
            title: '🎨 Начнем с фона',
            description: 'Для сертификата нужно красивое фоновое изображение. Это может быть ваш фирменный бланк или праздничный фон. Рекомендуем использовать изображения с высоким разрешением для качественного результата. ',
            placement: 'right',
            target: () => document.querySelector('.ant-collapse-item:nth-child(1)') || document.body,
        },
        {
            title: 'Загрузите изображение',
            description: 'Перетащите файл с фоном в эту область или нажмите для выбора файла. Поддерживаются форматы PNG, JPG, SVG. Рекомендуемый размер: 2000x1500 пикселей.',
            placement: 'right',
            target: () => document.querySelector('.ant-collapse-item:nth-child(1) .ant-upload-drag') || document.body,
        },
        {
            title: '✨ Отлично! Фон загружен',
            description: 'Теперь вы видите фон в центре экрана. Это рабочая область, где будет располагаться ваш сертификат. Давайте добавим на него текст.',
            placement: 'left',
            target: () => document.querySelector('.PreviewSectionWidget') || document.body,
        },
        {
            title: '📝 Добавляем текст',
            description: 'Текстовые блоки — это элементы, которые вы размещаете на сертификате. Это могут быть заголовки, имена получателей, даты, подписи и другие данные.',
            placement: 'right',
            target: () => document.querySelector('.ant-collapse-item:nth-child(2)') || document.body,
        },
        {
            title: 'Введите текст',
            description: 'Напишите любой текст, который хотите разместить на сертификате. Например: "Сертификат об окончании курса" или "Награждается".',
            placement: 'right',
            target: () => document.querySelector('[aria-label="text"]') || document.body,
        },
        {
            title: 'Добавьте блок',
            description: 'Нажмите кнопку "Добавить текстовый блок", чтобы разместить текст на сертификате.',
            placement: 'right',
            target: () => document.querySelector('.commit-block .ant-btn-primary') || document.body,
        },
        {
            title: '🎉 Прекрасно! Текст добавлен',
            description: 'Ваш текст появился на фоне. Теперь вы можете настроить его внешний вид: изменить цвет, шрифт, размер и положение.',
            placement: 'left',
            target: () => document.querySelector('.TextBlock') || document.body,
        },
        {
            title: 'Нажмите на блок для редактирования',
            description: 'Кликните на текст в предпросмотре, чтобы выделить его. Выбранный блок будет иметь синюю рамку и станет активным для редактирования.',
            placement: 'left',
            target: () => document.querySelector('.TextBlock') || document.body,
        },
        {
            title: '🎨 Измените цвет текста',
            description: 'Выберите любой цвет для текста в панели справа. Цвет можно выбрать из палитры или ввести HEX-код.',
            placement: 'right',
            target: () => document.querySelector('.ant-color-picker-trigger') || document.body,
        },
        {
            title: 'Обновите блок',
            description: 'После изменения настроек нажмите кнопку "Обновить блок", чтобы применить изменения к тексту на сертификате.',
            placement: 'right',
            target: () => document.querySelector('.commit-block .ant-btn-primary:has(.anticon-reload)') || document.body,
        },
        {
            title: '💫 Отлично! Текст изменился',
            description: 'Теперь ваш текст имеет новый цвет! Вы также можете перетаскивать блок мышкой в любое место на сертификате и изменять его размер.',
            placement: 'left',
            target: () => document.querySelector('.TextBlock') || document.body,
        },
        {
            title: '✅ Отлично! Первый блок готов',
            description: 'Вы успешно создали и настроили текстовый блок! Теперь давайте сохраним результат в файл.',
            placement: 'center',
            target: () => null,
        },
        {
            title: '💾 Сохраняем сертификат',
            description: 'Когда сертификат готов, его можно экспортировать в файл. Вы можете сохранить его как изображение.',
            placement: 'right',
            target: () => document.querySelector('.ant-collapse-item:nth-child(4)') || document.body,
        },
        {
            title: 'Выберите формат экспорта',
            description: 'Нажмите "Экспорт в PNG" для сохранения в формате изображения. PNG сохраняет прозрачность фона.',
            placement: 'right',
            target: () => document.querySelector('.ExportControl-space .ant-btn-primary:first-child') || document.body,
        },
        {
            title: '🎉 Поздравляем!',
            description: 'Вы создали и сохранили свой первый сертификат! Теперь вы знаете основы работы с редактором.',
            placement: 'center',
            target: () => null,
        },

        // Часть 2: CSV и массовая генерация
        {
            title: '📊 Теперь массовая генерация',
            description: 'Самое интересное! Если вам нужно создать много сертификатов (для группы или участников), можно использовать таблицу данных. Система автоматически создаст сертификаты для каждой строки в таблице.',
            placement: 'center',
            target: () => null,
        },
        {
            title: 'Скачайте шаблон CSV',
            description: 'Если вы не знаете формат CSV, скачайте готовый шаблон. Он покажет, как должна выглядеть таблица с данными.',
            placement: 'right',
            target: () => document.querySelector('.download-template-button') || document.body,
        },
        {
            title: 'Загрузите CSV файл',
            description: 'Загрузите подготовленную таблицу с данными. В каждой строке должны быть данные для одного сертификата. Система автоматически определит колонки.',
            placement: 'right',
            target: () => document.querySelector('.ant-collapse-item:nth-child(3) .ant-upload-drag') || document.body,
        },
        {
            title: '⚡ Магия автоматизации начинается',
            description: 'После загрузки CSV появилось модальное окно настройки. Здесь вы можете указать, как использовать данные из таблицы.',
            placement: 'center',
            target: () => null,
        },
        // Указатели в модалке импорта CSV
        {
            title: 'Автоматическое создание блоков',
            description: 'Поставьте флажок "Автоматически создать текстовые блоки". Система сама создаст текстовые блоки для каждой колонки в таблице!',
            placement: 'right',
            target: () => document.querySelector('.ant-modal-body .ant-checkbox-wrapper') || document.body,
        },
        {
            title: 'Выберите колонки для блоков',
            description: 'Отметьте галочками те колонки, из которых нужно создать текстовые блоки. Например, если у вас есть колонки "name" и "date", создадутся блоки для обеих.',
            placement: 'top',
            target: () => document.querySelector('.ant-modal-body .ant-table-thead .ant-checkbox-wrapper') || document.body,
        },
        {
            title: 'Настройка именования файлов',
            description: 'Выберите колонку, по которой будут называться сгенерированные файлы. Например, если выбрать колонку "name", файлы будут называться "Иван.png", "Мария.png" и т.д.',
            placement: 'top',
            target: () => document.querySelector('.ant-modal-body .ant-select-selector') || document.body,
        },
        {
            title: 'Предпросмотр данных',
            description: 'Здесь вы видите, как будут выглядеть данные в таблице. Проверьте, правильно ли определились колонки и нет ли ошибок в данных.',
            placement: 'bottom',
            target: () => document.querySelector('.ant-modal-body .ant-table') || document.body,
        },
        {
            title: 'Подтвердите импорт',
            description: 'Нажмите "Подтвердить импорт", чтобы система создала текстовые блоки из вашей таблицы.',
            placement: 'right',
            target: () => document.querySelector('.ant-modal-footer .ant-btn-primary') || document.body,
        },
        {
            title: '✨ Чудесно! Блоки созданы',
            description: 'Система автоматически создала все текстовые блоки из вашей таблицы! Теперь у вас есть готовый шаблон для массовой генерации.',
            placement: 'left',
            target: () => document.querySelector('.PreviewSectionWidget') || document.body,
        },
        {
            title: 'Настройте блоки под себя',
            description: 'Вы можете отредактировать положение, цвет и размер каждого блока. Настройте один раз — и все сертификаты будут выглядеть одинаково профессионально.',
            placement: 'left',
            target: () => document.querySelector('.PreviewSectionWidget') || document.body,
        },
        {
            title: '📦 Пакетный экспорт',
            description: 'Теперь, когда шаблон готов, можно создать сертификаты для всех строк таблицы одним кликом!',
            placement: 'right',
            target: () => document.querySelector('.ant-collapse-item:nth-child(4)') || document.body,
        },
        {
            title: 'Экспортируйте все сертификаты',
            description: 'Нажмите "Экспорт всех открыток (ZIP)". Система создаст отдельный файл для каждой строки таблицы и упакует их в ZIP архив для удобного скачивания.',
            placement: 'right',
            target: () => document.querySelector('.multiple-export .ant-btn-primary') || document.body,
        },
        {
            title: '🏆 Потрясающий результат!',
            description: 'Вы создали десятки или даже сотни сертификатов за несколько минут! Система упаковала их в ZIP архив, готовый к отправке или печати.',
            placement: 'center',
            target: () => null,
        },
        {
            title: '🎓 Обучение завершено!',
            description: 'Теперь вы мастер работы с генератором открыток! Вы умеете создавать как отдельные сертификаты, так и массовые наборы из таблицы данных!',
            placement: 'center',
            target: () => null,
        },
    ];

    useEffect(() => {
        if (!open) {
            const timer = setTimeout(() => {
                setCurrent(0);
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [open]);

    return (
        <Tour
            open={open}
            steps={steps}
            current={current}
            onChange={setCurrent}
            onClose={onClose}
            indicatorsRender={(current, total) => (
                <div style={{
                    background: 'rgba(0,0,0,0.7)',
                    color: 'white',
                    padding: '6px 12px',
                    borderRadius: '20px',
                    fontSize: '14px',
                    fontWeight: 'bold'
                }}>
                    {current + 1} / {total}
                </div>
            )}
            prevButtonProps={{
                children: '← Назад',
            }}
            nextButtonProps={{
                children: current === steps.length - 1 ? 'Завершить обучение 🎓' : 'Далее →',
                type: 'primary',
            }}
        />
    );
};

export default TourWidget;